import {useEffect, MutableRefObject} from 'react';
import WatchedPlaylist from 'app/components/tv/utils/WatchedPlaylist';
import Playlist from 'app/components/tv/models/Playlist';
import {VideoEvent} from 'app/components/tv/events/VideoEvent';
import {VideoJsPlayer} from 'video.js';
import Video from 'app/components/tv/models/video';

export const useWatchedPlaylistTracking = (
  playlist: Playlist | null,
  currentVideo: Video | null,
  playerRef: MutableRefObject<VideoJsPlayer | null>,
  playerReady: boolean
) => {
  useEffect(() => {
    const player = playerRef.current;
    if (!playlist?.hasVideos || !currentVideo) {
      return;
    }

    if (!player || !playerReady) {
      return;
    }

    const onPlayed25 = () => {
      const playlistId = playlist.getPlaylistId();
      const videoIndex = playlist.indexOf(currentVideo);
      if (videoIndex >= 0) {
        new WatchedPlaylist(playlistId).watch(videoIndex);
      }
    };

    player.one(VideoEvent.VideoPlayed25, onPlayed25);

    return () => {
      if (player) {
        player.off(VideoEvent.VideoPlayed25, onPlayed25);
      }
    };
  }, [playlist, currentVideo, playerReady]);
};
